export const messages = {
  en: {
    downloadTempFile: {
      title: 'Download Center',
      refresh: 'Refresh',
      name: 'Name',
      fileType: 'File Type',
      downloadUser: 'Downloader',
      downloadTime: 'Download Time',
      status: 'Status',
      remark: 'Remark',
      operation: 'Operation',
      download: 'Download',
      delete: 'Delete',
      fetchError: 'Failed to fetch file list'
    },
    deleteDownloadTempFile: {
      title: 'Please confirm your operation',
      confirmMessage: 'Are you sure to delete this file?',
      cancel: 'Cancel',
      confirm: 'Confirm Delete',
      deleteSuccess: 'File deleted successfully',
      deleteFailed: 'Failed to delete file'
    }
  },
  zh: {
    downloadTempFile: {
      title: '下载中心',
      refresh: '刷新',
      name: '名称',
      fileType: '文件类型',
      downloadUser: '下载人',
      downloadTime: '下载时间',
      status: '状态',
      remark: '备注',
      operation: '操作',
      download: '下载',
      delete: '删除',
      fetchError: '获取文件列表失败'
    },
    deleteDownloadTempFile: {
      title: '请确认您的操作',
      confirmMessage: '确定删除该文件吗？',
      cancel: '取消',
      confirm: '确认删除',
      deleteSuccess: '文件删除成功',
      deleteFailed: '文件刪除失敗'
    }
  },
  'zh-TW': {
    downloadTempFile: {
      title: '下載中心',
      refresh: '刷新',
      name: '名稱',
      fileType: '文件類型',
      downloadUser: '下載人',
      downloadTime: '下載時間',
      status: '狀態',
      remark: '備註',
      operation: '操作',
      download: '下載',
      delete: '刪除',
      fetchError: '獲取文件列表失敗'
    },
    deleteDownloadTempFile: {
      title: '請確認您的操作',
      confirmMessage: '確定刪除該文件嗎？',
      cancel: '取消',
      confirm: '確認刪除',
      deleteSuccess: '文件刪除成功',
      deleteFailed: '文件刪除失敗'
    }
  }
}